var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let AccountManagementModalTabs = class AccountManagementModalTabs extends Vue {
    get leftTabOfModal() {
        return this.$store.getters['admin/get_left_tab_of_modal'] || 'credits';
    }
    set leftTabOfModal(value) {
        this.$store.dispatch('admin/update_left_tab_of_modal', value);
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
    }
    get renderFeatureFlagsSettingsTab() {
        // @ts-ignore
        const user = this.$auth.user();
        return (user &&
            user.features &&
            user.features.includes('feature_flags_admin_panel'));
    }
};
AccountManagementModalTabs = __decorate([
    Component({
        name: 'AccountManagementModalTabs',
    })
], AccountManagementModalTabs);
export default AccountManagementModalTabs;
